import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

export default class Index extends React.Component {
  render() {
    return (
    <div>
    	<h1 style={{marginTop:"1.375rem"}}>Hello there!</h1>
    	<div>
	      <p>I'm Matthew Manuel, a full-stack developer passionate in all aspects of software development and startups.</p>
	      <p>I've worked in both enterprise and startup environments in various roles from support, quality assurance, development and product owner.</p>
	      <p>Currently based in London, UK, originally from Melbourne, Australia.</p>
      </div>
      <div>
      	<h4>What interests me right now ?</h4>
      	<ul>
	      	<li>Optimising cloud infrastructure in terms of cost and efficiency.</li>
	      	<li>Service monitoring/logging tools to increase agility for teams to respond to failure.</li>
	      	<li>Reducing cognitive load and tedious tasks through automation & chatops.</li>
	      	<li>Tools that enables us to understand customer behavior</li>
      	</ul>
      </div>
      <div>
      	<h4>Skills</h4>
	      <div>
		      	<ul>
			      	<li>Javascript, ES6+, React/Redux, Jest, Electron, Webpack, HTML/CSS</li>
			      	<li>Node.js, Express/Strongloop, MongoDB</li>
			      	<li>Git/Bitbucket, Docker, AWS</li>
		      	</ul>
	      	<p>While I currently identify myself as a JS hippie, I have experience in Xamarin C#, Swift, PHP, Unity too.</p>
	      </div>
    	</div>
    	<p>Hit me up, if you think there's something I'd be interested in!</p>
    </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.js